import React from 'react';

const ReturnFlightTabs = ({
  activeTab,
  onTabChange,
  searchData,
  departureAirport,
  arrivalAirport,
  lockedTabs = [],
}) => {
  const fromDisplay = departureAirport ? `${departureAirport.iata}` : searchData.from;
  const toDisplay = arrivalAirport ? `${arrivalAirport.iata}` : searchData.to;

  // Same display format as FlightCard: "Sat 30 May 26"
  const formatTabDate = (dateString) => {
    if (!dateString) return '';

    const raw = String(dateString).trim();
    if (/^(Mon|Tue|Wed|Thu|Fri|Sat|Sun)\s/i.test(raw)) {
      return raw;
    }

    const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
    const date = isoMatch
      ? new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]))
      : new Date(raw);

    if (Number.isNaN(date.getTime())) {
      return raw;
    }

    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const year = date.getFullYear().toString().slice(-2);
    return `${weekday} ${day} ${month} ${year}`;
  };

  const outboundLocked = lockedTabs.includes('outbound');
  const returnLocked = lockedTabs.includes('return');

  return (
    <div className="mb-4">
      <div className="flex gap-0">
        {/* Outbound Tab */}
        {outboundLocked ? (
          <div
            role="tab"
            aria-selected={activeTab === 'outbound'}
            title="Outbound leg is unchanged"
            className={`flex-1 px-6 py-4 text-center border-0 select-none max-md:px-2 max-md:py-3 ${
              activeTab === 'outbound'
                ? 'bg-[#ffd200] text-black'
                : 'bg-[#e6e6e6] text-[#888] cursor-default opacity-70'
            }`}
            style={{ minHeight: '70px' }}
          >
            <div className="font-bold text-base max-md:text-sm">
              {fromDisplay} → {toDisplay} 🔒
            </div>
            <div className="text-sm font-bold mt-1 max-md:text-xs">
              {formatTabDate(searchData.departure)}
            </div>
          </div>
        ) : (
          <button
            type="button"
            onClick={() => onTabChange('outbound')}
            className={`flex-1 px-6 py-4 text-center transition-colors border-0 max-md:px-2 max-md:py-3 ${activeTab === 'outbound'
                ? 'bg-[#ffd200] text-black'
                : 'bg-[#e6e6e6] text-black hover:bg-[#d9d9d9]'
              }`}
            style={{ minHeight: '70px' }}
          >
            <div className="font-bold text-base max-md:text-sm">
              {fromDisplay} → {toDisplay}
            </div>
            <div className="text-sm font-bold mt-1 max-md:text-xs">
              {formatTabDate(searchData.departure)}
            </div>
          </button>
        )}

        {/* Return Tab — display only unless locked for partial change */}
        <div
          role="tab"
          aria-selected={activeTab === 'return'}
          title={returnLocked ? 'Return leg is unchanged' : 'Select an outbound flight to view return options'}
          className={`flex-1 px-6 py-4 text-center border-0 select-none max-md:px-2 max-md:py-3 ${
            activeTab === 'return'
              ? 'bg-[#ffd200] text-black'
              : 'bg-[#e6e6e6] text-[#888] cursor-default opacity-70'
          }`}
          style={{ minHeight: '70px' }}
        >
          <div className="font-bold text-base max-md:text-sm">
            {toDisplay} → {fromDisplay}{returnLocked ? ' 🔒' : ''}
          </div>
          <div className="text-sm font-bold mt-1 max-md:text-xs">
            {formatTabDate(searchData.return)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnFlightTabs;
